export const selects = state => state.theme.selects.map(index => state.theme.items[index])
